export function getFileInformation(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      // Extract the MIME type
      const mimeType = file.type;
      // Extract the file name
      const fileName = file.name;
      // Extract the base64 content
      const base64Content = reader.result.split(',')[1];

      resolve({ fileName, mimeType, base64Content });
    };

    reader.onerror = () => {
      reject(new Error('Error reading file'));
    };

    // Read the file as base64
    reader.readAsDataURL(file);
  });
}
